import {Alert, Box, CircularProgress, CssBaseline, Stack} from '@mui/material';
import * as React from 'react';
import Header from '@/components/Header';
import {useUserContext} from '@/components/Providers/UserContext';
import TableDigitalCodes from '@/components/DigitalCode/TableDigitalCodes';
import useFetchDigitalCodes from '@/queries/useFetchDigitalCodes';
import {type MutateFunctionError} from '@/types/MutateFunctionError';

const MyDigitalCodes = () : React.ReactElement => {
    const {user} = useUserContext();
    const digitalCodesQuery = useFetchDigitalCodes();
    const digitalCodes = digitalCodesQuery.data?.data;
    const digitalCodesInfoMessage = digitalCodesQuery.data?.message;
    const digitalCodesErrorCode = digitalCodesQuery.data?.errorCode;
    const digitalCodesQueryError = digitalCodesQuery.error as MutateFunctionError;

    return <React.Fragment>
        <CssBaseline/>
        <Header/>
        <Stack
            sx={{
                flexGrow: 1,
                backgroundColor: '#631d79',
                height: '100%',
            }}
        >
            <Stack
                direction='column'
                justifyContent='flex-start'
                sx={{
                    backgroundColor: '#fff',
                    m: 2,
                    mt: '125px',
                    flexGrow: 1,
                    overflow: 'auto',
                }}
            >
                {(digitalCodesQuery.isLoading || user === undefined) && <Stack
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    sx={{
                        height: '100%',
                    }}
                >
                    <CircularProgress/>
                </Stack>}

                {!digitalCodesQuery.isLoading && <Stack
                    direction='row'
                    justifyContent='center'
                >
                    {digitalCodes && digitalCodes.length === 0 && <Alert severity='error' sx={{my: 2}}>No Digital Codes Found</Alert>}
                    {digitalCodesQuery.isError && <Alert severity='error' sx={{my: 2}}>{digitalCodesQueryError.message}</Alert>}
                    {digitalCodesErrorCode !== 0 && digitalCodesInfoMessage && <Alert severity='info' sx={{my: 2}}>{digitalCodesInfoMessage}</Alert>}
                </Stack>}

                {digitalCodes && digitalCodes.length > 0 && <Box sx={{width: '100%'}}>
                    <TableDigitalCodes digitalCodes={digitalCodes}/>
                </Box>}
            </Stack>
        </Stack>
    </React.Fragment>;
};

export default MyDigitalCodes;
